import { render, staticRenderFns } from "./ExportarRelatorio.vue?vue&type=template&id=e6c92e70&scoped=true"
import script from "./ExportarRelatorio.vue?vue&type=script&lang=js"
export * from "./ExportarRelatorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c92e70",
  null
  
)

export default component.exports